export default {
  footerSponsors: true,

  loadingScreen_App: false,
  homepageNews_App: false,
  newsListing_App: false,
  matchCentre_FirstTeam_App: false,
  fixturesPage_FirstTeam_App: false,
  playerOfTheMatch_App: false,
  scorePredictor_App: false,

  homepageNews_Web: true,
  newsListing_Web: true,
  matchCentre_FirstTeam_Web: true,
  fixturesPage_FirstTeam_Web: true,
  playerOfTheMatch_Web: true,
}
